export default function ({ app }, inject) {
  inject('calendar', {
    /**
     * Функция isDark принимает значение цвета и необязательный логический параметр, чтобы определить,
     * является ли цвет темным, возвращая либо true, либо false в зависимости от яркости цвета.
     * @param color - Параметр «color» представляет собой шестнадцатеричное значение цвета, представленное
     * в виде строки, например, «#FFA500» для оранжевого цвета или «#008000» для зеленого.
     * @param isCheck - Параметр isCheck представляет собой логический флаг, который определяет, должна ли
     * функция возвращать логическое значение, указывающее, является ли цвет темным или светлым («true»),
     * или возвращать соответствующий код светлого или темного цвета («false»).
     * @returns Функция isDark возвращает либо true, либо false в зависимости от яркости предоставленного
     * цвета. Если параметр isCheck имеет значение true, он возвращает true, если цвет считается темным
     * (яркость < 128), в противном случае возвращается false. Если `isCheck` не имеет значения `true`, он
     * возвращает цвет `#FFFFFF`, если цвет темный
     */
    isDark(color, isCheck) {
      const rgb = parseInt(color.slice(1), 16)
      const r = (rgb >> 16) & 0xff
      const g = (rgb >> 8) & 0xff
      const b = (rgb >> 0) & 0xff
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      if (isCheck === true) return brightness < 128
      else return brightness < 128 ? '#FFFFFF' : '#000000'
    },
  })
}
